import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['component'];

  toggleActive() {
    this.element.classList.toggle(`instance-list-dropdown--active`)
  }
}
